/**
 * Progress surface — compact (cashflow) or full engagement panel (dashboard).
 */
import React from 'react';
import EngagementProgressPanel from './EngagementProgressPanel';

const ProgressPanel = ({ progress, compact = false }) => {
  if (!progress) return null;
  return <EngagementProgressPanel progress={progress} compact={compact} />;
};

export default ProgressPanel;
